import client from './client';

export const zendeskApiGet = (data = {}) => client().get('/zendesk/sso', { params: data });
export const zendeskApiPost = (data = {}) => client().post('/zendesk', data);
